<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>検索結果</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="table-responsive" style="max-height: 500px;">
            <table mat-table [dataSource]="dataSource" matSort style="min-width:2500px;" #sort1="matSort">
                <ng-container matColumnDef="regist">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 2em; width: 2em;">
                        対象</th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        <mat-checkbox color="primary" (change)="$event ? selection.toggle(row) : null; onChangeRegist()"
                            [checked]="selection.isSelected(row)" (dbclick)="$event?.stopPropagation()">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="businessClsfy">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 75px;">業務種別</th>
                    <td mat-cell *matCellDef="let row">{{ row.businessClsfy }}</td>
                </ng-container>
                <ng-container matColumnDef="apprvJokyo">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 80px;">承認状況</th>
                    <td mat-cell *matCellDef="let row">{{ row.apprvJokyo }}</td>
                </ng-container>
                <ng-container matColumnDef="apprvReqYearmonthdate">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 80px;">承認依頼日</th>
                    <td mat-cell *matCellDef="let row">{{ row.apprvReqYearmonthdate | dateString }}</td>
                </ng-container>
                <ng-container matColumnDef="payCtrNo">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 120px;">支払契約番号</th>
                    <td mat-cell *matCellDef="let row">{{ row.payCtrNo }}</td>
                </ng-container>
                <ng-container matColumnDef="visitName">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 85px;">請求先名</th>
                    <td mat-cell *matCellDef="let row">{{ row.visitName }}</td>
                </ng-container>
                <ng-container matColumnDef="rcvmnyNo">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 80px;">入金番号</th>
                    <td mat-cell *matCellDef="let row">{{ row.rcvmnyNo }}</td>
                </ng-container>
                <ng-container matColumnDef="receivemoneydate">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 75px;">入金日</th>
                    <td mat-cell *matCellDef="let row">{{ row.receivemoneydate | dateString}}</td>
                </ng-container>
                <ng-container matColumnDef="inmny">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 105px;">入金額[円]</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.inmny|number}}</td>
                </ng-container>
                <ng-container matColumnDef="kinkoAmt">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 105px;">未精算額[円]</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.kinkoAmt|number}}</td>
                </ng-container>
                <ng-container matColumnDef="jikaiClaimPlndate">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 105px;">次回請求予定日</th>
                    <td mat-cell *matCellDef="let row">{{ row.jikaiClaimPlndate | dateString }}</td>
                </ng-container>
                <ng-container matColumnDef="rcvmnyKeitai">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 70px;">入金形態</th>
                    <td mat-cell *matCellDef="let row">{{ row.rcvmnyKeitai }}</td>
                </ng-container>
                <ng-container matColumnDef="kinkoStatuscode">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 70px;">未精算ステータス</th>
                    <td mat-cell *matCellDef="let row">{{ row.kinkoStatuscode }}</td>
                </ng-container>
                <ng-container matColumnDef="kinkoReason">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 280px;">未精算理由</th>
                    <td mat-cell *matCellDef="let row">{{ row.kinkoReason }}</td>
                </ng-container>
                <ng-container matColumnDef="kouzaReg">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 66px;">口座登録</th>
                    <td mat-cell *matCellDef="let row" class="text-center">{{ row.kouzaReg }}</td>
                </ng-container>
                <ng-container matColumnDef="effectCtrUmu">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 90px;">有効契約有無</th>
                    <td mat-cell *matCellDef="let row" class="text-center">{{ row.effectCtrUmu}}</td>
                </ng-container>
                <ng-container matColumnDef="transferdestinationPaymentcontractNo">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 130px;">振替先支払契約番号</th>
                    <td mat-cell *matCellDef="let row">{{ row.transferdestinationPaymentcontractNo }}</td>
                </ng-container>
                <ng-container matColumnDef="transferdestinationClmtoMei">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 105px;">振替先請求先名</th>
                    <td mat-cell *matCellDef="let row">{{ row.transferdestinationClmtoMei }}</td>
                </ng-container>
                <ng-container matColumnDef="funoReason">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 280px;">不能理由</th>
                    <td mat-cell *matCellDef="let row">{{ row.funoReason }}</td>
                </ng-container>
                <ng-container matColumnDef="trnTntsh">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 85px;">処理担当者</th>
                    <td mat-cell *matCellDef="let row">{{ row.trnTntsh }}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCol" [class]="'clickable-mat-row'"
                    (dblclick)="onDblClickRow(row)"></tr>
            </table>
        </div>
        <mat-paginator #paginator1 [pageSize]="10" showFirstLastButtons></mat-paginator>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
            <mat-card-actions class="btn_area_right">
                <button type="button" (click)="onClickRepayInfo()" mat-raised-button color="primary" class="btn"
                    [disabled]="!this.isRepayStatus">
                    返金内容確認
                </button>
                <button type="button" (click)="onClickApproval()" mat-raised-button color="primary" class="btn"
                    [disabled]="!this.isApproval">承認</button>
            </mat-card-actions>
        </div>
    </mat-card-content>
</mat-card>